// Fetch the complete snapshot before writing: marking read must not shift pagination.
export async function readAllNotificationIds(fetchPage, field, userId) {
    const ids = [], seen = new Set();
    let offset = 0;
    while (true) {
        const response = await fetchPage(userId, 100, offset);
        const page = response?.[field];
        if (response?.error || !page || page.errKey || !Array.isArray(page.data) || !Number.isFinite(page.total)) {
            throw new Error("Could not load notifications");
        }
        if (page.data.some(item => !item?._id || seen.has(item._id))) throw new Error("Notification pagination did not advance");
        for (const item of page.data) {
            seen.add(item._id);
            if (!item.isRead) ids.push(item._id);
        }
        offset += page.data.length;
        if (offset >= page.total) return ids;
        if (!page.data.length) throw new Error("Incomplete notification page");
    }
}

export function assertReadResult(response, field) {
    const result = response?.[field];
    const success = result === true || result?.status?.toLowerCase() === "success" ||
        (Array.isArray(result) && result.length > 0 && result.every(item => item?.isRead === true));
    if (response?.error || !success) throw new Error("Notification update failed");
}

export async function markNotificationSourcesRead(sources, userId) {
    const outcomes = await Promise.allSettled(sources.map(async ({fetchPage, listField, update, updateField}) => {
        const ids = await readAllNotificationIds(fetchPage, listField, userId);
        for (let start = 0; start < ids.length; start += 100) {
            assertReadResult(await update(ids.slice(start, start + 100), true), updateField);
        }
    }));
    if (outcomes.some(result => result.status === "rejected")) throw new Error("Some notifications could not be marked as read");
}
